module.exports = "/images/close_white.svg?76e82561b6b76188a4f08dddab2a41b1";